import { nextTick, ref, toRaw } from 'vue'
import { showOemList } from '@/apis/associated'

export const formatOemProduct = (v: any, rate: number) => ({
  ...v,
  id: v.searchSourceOrderNo,
  code: v.searchSourceOrderNo,
  name: v.productName,
  img: v.productImg,
  type: 'oem',
  price: v.biggestprice ?? 0,
  PriceJpy: (v.biggestprice ?? 0) * rate ? Math.floor((v.biggestprice ?? 0) * rate) : 0
})
const formatOemProductArr = (data: any, rate: number) => {
  console.log(rate)
  return (data || []).map((t: any) => formatOemProduct(t, rate))
}
export default (model: any, keyword: any, rate:any, emits: any) => {
  const loading: any = ref(false)
  const list: any = ref([])
  const total = ref()
  const pageData = ref({
    pageNum: 1,
    pageSize: 50
  })

  const getList = () => {
    loading.value = true
    showOemList({
      productName: keyword.value?.trim(),
      priceStart: model.value.sellPriceStart,
      priceEnd: model.value.sellPriceEnd,
      ...toRaw(pageData.value)
    }).then((res: any) => {
      list.value = formatOemProductArr(res.data?.records, rate.value)
      total.value = res.data.total
      nextTick(() => {
        emits('update:list', list.value)
      })
    }).finally(() => { loading.value = false })
  }

  return [
    loading,
    pageData,
    list,
    total,
    getList
  ]
}
